module.exports = __webpack_public_path__ + "static/media/infracciones_camaras_vias.20b6618e.svg";